/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * ZEP QUIZ
 * Zep Quiz API
 * OpenAPI spec version: 0.0.1
 */
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';
import { useMutation, useQuery, useSuspenseQuery } from '@tanstack/react-query';

import type { BodyType, ErrorType } from '../../httpClient';
import { httpsInstance } from '../../httpClient';
import type { GetPlanManagementParams } from '../_model/getPlanManagementParams';
import type { PlanInquiryRequest } from '../_model/planInquiryRequest';
import type { SuccessBody } from '../_model/successBody';
import type { SuccessBodyGetCurrentPlanOptionsResponse } from '../_model/successBodyGetCurrentPlanOptionsResponse';
import type { SuccessBodyGetQuizPlanOptionsResponseWithIsPaidOwner } from '../_model/successBodyGetQuizPlanOptionsResponseWithIsPaidOwner';
import type { SuccessBodyPlanManagementResponse } from '../_model/successBodyPlanManagementResponse';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

export const submitPlanInquiry = (
  planInquiryRequest: BodyType<PlanInquiryRequest>,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBody>(
    {
      url: `/quiz-plans/inquiries`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: planInquiryRequest,
      signal,
    },
    options,
  );
};

export const getSubmitPlanInquiryMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof submitPlanInquiry>>,
    TError,
    { data: BodyType<PlanInquiryRequest> },
    TContext
  >;
  request?: SecondParameter<typeof httpsInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof submitPlanInquiry>>,
  TError,
  { data: BodyType<PlanInquiryRequest> },
  TContext
> => {
  const mutationKey = ['submitPlanInquiry'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof submitPlanInquiry>>,
    { data: BodyType<PlanInquiryRequest> }
  > = props => {
    const { data } = props ?? {};

    return submitPlanInquiry(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SubmitPlanInquiryMutationResult = NonNullable<
  Awaited<ReturnType<typeof submitPlanInquiry>>
>;
export type SubmitPlanInquiryMutationBody = BodyType<PlanInquiryRequest>;
export type SubmitPlanInquiryMutationError = ErrorType<unknown>;

export const useSubmitPlanInquiry = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof submitPlanInquiry>>,
      TError,
      { data: BodyType<PlanInquiryRequest> },
      TContext
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof submitPlanInquiry>>,
  TError,
  { data: BodyType<PlanInquiryRequest> },
  TContext
> => {
  const mutationOptions = getSubmitPlanInquiryMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const getCurrentPlanOptions = (
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyGetCurrentPlanOptionsResponse>(
    { url: `/quiz-plans/options`, method: 'GET', signal },
    options,
  );
};

export const getGetCurrentPlanOptionsQueryKey = () => {
  return [`/quiz-plans/options`] as const;
};

export const getGetCurrentPlanOptionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getCurrentPlanOptions>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getCurrentPlanOptions>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof httpsInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCurrentPlanOptionsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCurrentPlanOptions>>
  > = ({ signal }) => getCurrentPlanOptions(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCurrentPlanOptions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetCurrentPlanOptionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCurrentPlanOptions>>
>;
export type GetCurrentPlanOptionsQueryError = ErrorType<unknown>;

export function useGetCurrentPlanOptions<
  TData = Awaited<ReturnType<typeof getCurrentPlanOptions>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCurrentPlanOptions>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCurrentPlanOptions>>,
          TError,
          Awaited<ReturnType<typeof getCurrentPlanOptions>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetCurrentPlanOptions<
  TData = Awaited<ReturnType<typeof getCurrentPlanOptions>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCurrentPlanOptions>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCurrentPlanOptions>>,
          TError,
          Awaited<ReturnType<typeof getCurrentPlanOptions>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetCurrentPlanOptions<
  TData = Awaited<ReturnType<typeof getCurrentPlanOptions>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCurrentPlanOptions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetCurrentPlanOptions<
  TData = Awaited<ReturnType<typeof getCurrentPlanOptions>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCurrentPlanOptions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetCurrentPlanOptionsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetCurrentPlanOptionsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getCurrentPlanOptions>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof getCurrentPlanOptions>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof httpsInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCurrentPlanOptionsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCurrentPlanOptions>>
  > = ({ signal }) => getCurrentPlanOptions(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getCurrentPlanOptions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetCurrentPlanOptionsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCurrentPlanOptions>>
>;
export type GetCurrentPlanOptionsSuspenseQueryError = ErrorType<unknown>;

export function useGetCurrentPlanOptionsSuspense<
  TData = Awaited<ReturnType<typeof getCurrentPlanOptions>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getCurrentPlanOptions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetCurrentPlanOptionsSuspense<
  TData = Awaited<ReturnType<typeof getCurrentPlanOptions>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getCurrentPlanOptions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetCurrentPlanOptionsSuspense<
  TData = Awaited<ReturnType<typeof getCurrentPlanOptions>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getCurrentPlanOptions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};

export function useGetCurrentPlanOptionsSuspense<
  TData = Awaited<ReturnType<typeof getCurrentPlanOptions>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getCurrentPlanOptions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
} {
  const queryOptions = getGetCurrentPlanOptionsSuspenseQueryOptions(options);

  const query = useSuspenseQuery(
    queryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getPlanManagement = (
  params?: GetPlanManagementParams,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyPlanManagementResponse>(
    { url: `/quiz-plans/management`, method: 'GET', params, signal },
    options,
  );
};

export const getGetPlanManagementQueryKey = (
  params?: GetPlanManagementParams,
) => {
  return [`/quiz-plans/management`, ...(params ? [params] : [])] as const;
};

export const getGetPlanManagementQueryOptions = <
  TData = Awaited<ReturnType<typeof getPlanManagement>>,
  TError = ErrorType<unknown>,
>(
  params?: GetPlanManagementParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPlanManagement>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetPlanManagementQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPlanManagement>>
  > = ({ signal }) => getPlanManagement(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPlanManagement>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetPlanManagementQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPlanManagement>>
>;
export type GetPlanManagementQueryError = ErrorType<unknown>;

export function useGetPlanManagement<
  TData = Awaited<ReturnType<typeof getPlanManagement>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | GetPlanManagementParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPlanManagement>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlanManagement>>,
          TError,
          Awaited<ReturnType<typeof getPlanManagement>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetPlanManagement<
  TData = Awaited<ReturnType<typeof getPlanManagement>>,
  TError = ErrorType<unknown>,
>(
  params?: GetPlanManagementParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPlanManagement>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlanManagement>>,
          TError,
          Awaited<ReturnType<typeof getPlanManagement>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetPlanManagement<
  TData = Awaited<ReturnType<typeof getPlanManagement>>,
  TError = ErrorType<unknown>,
>(
  params?: GetPlanManagementParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPlanManagement>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetPlanManagement<
  TData = Awaited<ReturnType<typeof getPlanManagement>>,
  TError = ErrorType<unknown>,
>(
  params?: GetPlanManagementParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPlanManagement>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetPlanManagementQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetPlanManagementSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getPlanManagement>>,
  TError = ErrorType<unknown>,
>(
  params?: GetPlanManagementParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getPlanManagement>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetPlanManagementQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPlanManagement>>
  > = ({ signal }) => getPlanManagement(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getPlanManagement>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetPlanManagementSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPlanManagement>>
>;
export type GetPlanManagementSuspenseQueryError = ErrorType<unknown>;

export function useGetPlanManagementSuspense<
  TData = Awaited<ReturnType<typeof getPlanManagement>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | GetPlanManagementParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getPlanManagement>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetPlanManagementSuspense<
  TData = Awaited<ReturnType<typeof getPlanManagement>>,
  TError = ErrorType<unknown>,
>(
  params?: GetPlanManagementParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getPlanManagement>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetPlanManagementSuspense<
  TData = Awaited<ReturnType<typeof getPlanManagement>>,
  TError = ErrorType<unknown>,
>(
  params?: GetPlanManagementParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getPlanManagement>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};

export function useGetPlanManagementSuspense<
  TData = Awaited<ReturnType<typeof getPlanManagement>>,
  TError = ErrorType<unknown>,
>(
  params?: GetPlanManagementParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getPlanManagement>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
} {
  const queryOptions = getGetPlanManagementSuspenseQueryOptions(
    params,
    options,
  );

  const query = useSuspenseQuery(
    queryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @deprecated
 */
export const getQuizPlanOptions = (
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyGetQuizPlanOptionsResponseWithIsPaidOwner>(
    { url: `/quiz-plan-options`, method: 'GET', signal },
    options,
  );
};

export const getGetQuizPlanOptionsQueryKey = () => {
  return [`/quiz-plan-options`] as const;
};

export const getGetQuizPlanOptionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getQuizPlanOptions>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getQuizPlanOptions>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof httpsInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetQuizPlanOptionsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getQuizPlanOptions>>
  > = ({ signal }) => getQuizPlanOptions(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getQuizPlanOptions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetQuizPlanOptionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getQuizPlanOptions>>
>;
export type GetQuizPlanOptionsQueryError = ErrorType<unknown>;

export function useGetQuizPlanOptions<
  TData = Awaited<ReturnType<typeof getQuizPlanOptions>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuizPlanOptions>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuizPlanOptions>>,
          TError,
          Awaited<ReturnType<typeof getQuizPlanOptions>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetQuizPlanOptions<
  TData = Awaited<ReturnType<typeof getQuizPlanOptions>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuizPlanOptions>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuizPlanOptions>>,
          TError,
          Awaited<ReturnType<typeof getQuizPlanOptions>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetQuizPlanOptions<
  TData = Awaited<ReturnType<typeof getQuizPlanOptions>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuizPlanOptions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @deprecated
 */

export function useGetQuizPlanOptions<
  TData = Awaited<ReturnType<typeof getQuizPlanOptions>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuizPlanOptions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetQuizPlanOptionsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetQuizPlanOptionsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getQuizPlanOptions>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof getQuizPlanOptions>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof httpsInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetQuizPlanOptionsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getQuizPlanOptions>>
  > = ({ signal }) => getQuizPlanOptions(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getQuizPlanOptions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetQuizPlanOptionsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getQuizPlanOptions>>
>;
export type GetQuizPlanOptionsSuspenseQueryError = ErrorType<unknown>;

export function useGetQuizPlanOptionsSuspense<
  TData = Awaited<ReturnType<typeof getQuizPlanOptions>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizPlanOptions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetQuizPlanOptionsSuspense<
  TData = Awaited<ReturnType<typeof getQuizPlanOptions>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizPlanOptions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetQuizPlanOptionsSuspense<
  TData = Awaited<ReturnType<typeof getQuizPlanOptions>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizPlanOptions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
/**
 * @deprecated
 */

export function useGetQuizPlanOptionsSuspense<
  TData = Awaited<ReturnType<typeof getQuizPlanOptions>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizPlanOptions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
} {
  const queryOptions = getGetQuizPlanOptionsSuspenseQueryOptions(options);

  const query = useSuspenseQuery(
    queryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
